<template>
<div class="page">
  <div class="card">
    <div class="left">
        <div style="margin-top: 20vw;font-size: 25px;font-weight: 600">{{message.name}}</div>
        <div style="margin-top: 5px">{{message.job}}</div>
    </div>
    <div class="right">
        <div class="messageArea">
        <div class="item"><i class="fa fa-phone icon" style="font-size:17px;"></i><span class="item_name">手机:</span><el-input v-model="message.phone" :disabled="edit" class="item_content"></el-input></div>
        <div class="item"><i class="fa fa-wechat icon" style="font-size:12px;"></i><span class="item_name">微信:</span><el-input v-model="message.wechat" :disabled="edit" class="item_content" ></el-input></div>
        <div class="item"><i class="fa fa-envelope icon " style="font-size:14px;"></i><span class="item_name">邮箱:</span><el-input v-model="message.email" :disabled="edit" class="item_content"></el-input></div>
        <div class="item"><i class="fa fa-map-marker icon " style="font-size:23px;"></i><span class="item_name">地址:</span><el-input v-model="message.address" :disabled="edit" class="item_content"></el-input></div>
        </div>
    </div>
</div>
<div v-if="edit == true">
<div id="qr" class="qr"></div>
<div v-if="saveIdCardDialogShow == true" style="text-align:center;font-size:15px;">长按选择识别二维码，保存名片</div>
<div class="bottom">
    <el-button class="btn" @click="addCard">添加至通讯录</el-button>
    <el-button class="btn" @click="$router.push('/qrgenerate/qrIDcard')">制作名片二维码</el-button>    
</div>
</div>
<div v-else>
  <el-button class="btn" @click="updateCard" style="margin-top:20vh;">更新名片</el-button>
</div>
</div>
</template>

<script>
import $ from 'jquery'
import QRCode from 'qrcodejs2'
export default {
  data () {
    return {
      message: undefined, // 名片信息
      saveIdCardDialogShow: false,
      edit: true // 名片信息禁止编辑
    }
  },
  methods: {
    addCard () {
      const vm = this
      if (vm.saveIdCardDialogShow === false) {
        vm.saveIdCardDialogShow = true
        let qrcode = new QRCode(document.getElementById('qr'), {width: 100, height: 100})
        qrcode.clear()
        qrcode.makeCode('BEGIN:VCARD\nFN:' + vm.message.name + '\nORG:' + vm.message.company + '\nADR;TYPE=WORK:' + vm.message.address + '\nTITLE:' + vm.message.job + '\nTEL;WORK:' + vm.message.phone + '\nEMAIL;TYPE=PREF,INTERNET:' + vm.message.email + '\nEND:VCARD')
      }
    },
    updateCard () {
      const vm = this
      let passTest = true
      if (passTest === true && vm.message.phone.length !== 11) {
        vm.$message.warning('手机号格式有误，请重新输入')
        passTest = false
      }
      if (passTest === true && vm.message.wechat.length > 20) {
        vm.$message.warning('微信号过长')
        passTest = false
      }
      if (passTest === true && vm.message.email.length > 30) {
        vm.$message.warning('邮箱过长')
        passTest = false
      }
      if (passTest === true && vm.message.wechat.address > 20) {
        vm.$message.warning('地址过长')
        passTest = false
      }
      if (passTest) {
        $.ajax({
          type: 'POST',
          url: '/v1/idcard/update',
          data: {qrid: vm.$route.query.qrid, message: JSON.stringify(vm.message)},
          dataType: 'json',
          success: function (response) {
            if (response.data === 'ok') {
              vm.$message.success('更新成功！')
            }
            vm.$router.push('/labelManage')
          }
        })
      }
    }
  },
  mounted () {
    const vm = this
    let id = this.$route.query.qrid
    let wantToEdit = this.$route.query.edit
    $.ajax({
      type: 'GET',
      url: '/v1/idcard/info',
      data: {qrid: id},
      dataType: 'json',
      success: function (response) {
        vm.message = response.data
      }
    })
    if (wantToEdit === 'true') {
      $.ajax({
        type: 'GET',
        url: '/v1/idcard/editable',
        data: {qrid: id},
        dataType: 'json',
        success: function (response) {
          if (response.data === 'ok') {
            vm.edit = false
          }
        }
      })
    }
  },
  created () {
    // 适配屏幕
    document.head.querySelector('meta[name=viewport]').content = 'width=device-width, initial-scale=1, maximum-scale=1'
  }
}
</script>

<style scoped>
        .page {
            /*text-align: center;*/
            width: 100vw;
            height: 100vh;
            position: absolute;
            top: 0px;
            /* overflow: hiddsen; */
            /* background-image: url("../../assets/img/idCardQr/desk.jpg"); */
            background-size: cover;
            background-repeat: no-repeat;
        }
        .card {
          margin-top: 3vh;
            border: 1px solid #000000;
            box-shadow: 5px 5px 2px #000000;
            width: 94vw;
            margin-left: 3vw;
            height: 55vw;
            text-align: center;
            font-size: 20px;
            background-image: url("../../assets/img/idCardQr/back.jpg");
            font-weight: 500;
        }
        .left {
            width: 30%;
            height: 100%;
            float: left;
        }
        .right {
            font-size: 15px;
            text-align: left;
            width: 70%;
            height: 100%;
            float: left;
        }
        .item {
            height: 8vw;
            display: flex;
            align-items: center;
            word-break: break-all;
            word-wrap: break-word;
        }
        .messageArea {
            margin-top: 7vw;
            border-left: 2px solid #fe816d;
        }
        .icon {
            margin-right: 1vw;
            margin-left: 5vw;
        }
        .bottom {
            width: 94vw;
            margin-left: 3vw;
            margin-top: 0px;
            /* border: 1px solid #000000;
            box-shadow: 5px 5px 2px #000000; */
        }
        .btn {
            margin-top: 5vw;
            width: 80vw;
            margin-left: 10vw;
            font-size: 15px;
            border-radius: 20px;
            background: #fe816d;
            color: white;
            border: 1px solid #fe816d;
            box-shadow: 5px 5px 5px #663932;
        }
        .foot {
            width: 100vw;
            text-align: center;
            font-size: 40px;
            position: absolute;
            bottom: 0px;
        }
        a:link,a:visited {
            color: #fe816d;
        }
        .qr {
          height: 100px;
          width: 100px;
          margin: 5vh auto;
          background-image: url('../../assets/img/idCardQr/下载.png');
          background-repeat: no-repeat;
          background-size: contain;
        }
        .item_name {
          width: 60px;
          font-weight: 800;
        }
</style>
